<div class="d-flex align-items-center justify-content-center mb-3"
     [class.flex-row]="sideLegend"
     [class.flex-column]="!sideLegend">
    <dx-pie-chart
        type="doughnut"
        [dataSource]="chartItems"
        [innerRadius]="0.7"
        centerTemplate="centerTemplate"
        [customizePoint]="customizePoint"
        (onInitialized)="onChartInitialized($event)"
    >
        <dxo-pie-chart-size [height]="responsive ? 300 : 220"></dxo-pie-chart-size>
        <dxi-series argumentField="argument" valueField="value">
            <dxo-label [visible]="false"></dxo-label>
        </dxi-series>
        <dxo-tooltip
            [enabled]="hasData"
            [customizeTooltip]="customizeTooltip"
            format="millions"
        >
        </dxo-tooltip>
        <dxo-legend [visible]="false"></dxo-legend>
        <svg *dxTemplate="let pieChart of 'centerTemplate'">
            <text text-anchor="middle" style="fill: currentColor;" [style.font-size.px]="centerFontSize" x="100" y="120">
               <tspan x="100" dy="0">{{ centerLabel }}</tspan>
                <tspan
                    class="text-body-secondary"
                    x="100" dy="20"
                    style="font-size: 14px; fill: currentColor;">{{ centerText }}
                </tspan>
            </text>
        </svg>
    </dx-pie-chart>

    <div class="d-flex flex-wrap justify-content-center column-gap-3 row-gap-2"
         [class.flex-column]="sideLegend"
         [class.ms-4]="sideLegend"
         [class.mt-3]="!sideLegend">
        @for (item of legendItems; track item.argument) {
            <span class="d-inline-flex align-items-center"
                  style="cursor: pointer;"
                  [class.opacity-50]="hiddenArguments.has(item.argument)"
                  (click)="onLegendClick(item.argument)"
                  (mouseenter)="onLegendHover(item.argument, true)"
                  (mouseleave)="onLegendHover(item.argument, false)">
                <span class="rounded-circle me-1 flex-shrink-0"
                      style="width: 14px; height: 14px;"
                      [style.background]="legendColor(item.argument)"></span>
                <small class="text-body-secondary"
                       [class.text-decoration-line-through]="hiddenArguments.has(item.argument)">{{ legendLabel(item.argument) }}</small>
            </span>
        }
    </div>
</div>
